exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translations-component .dropdown-toggle:after{display:none}", ""]);

// exports
